// react
import React from 'react';
import AccountFormRegister from './AccountFormRegister';

function Register() {
    return <AccountFormRegister type="Crear" RegisterCheckout />;
}

export default Register;
